// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@turnerBlueprint/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { css } from "styled-components";

linkListStyles.title = {
    variant: "h5",
    forwardAs: "h6",
    transform: "uppercase",
};

linkListStyles.linkListWrapper = {};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;

        &.horizontal {
            flex-direction: row;
        }
    `,
};

linkListStyles.link = {
    mergeCss: true,
    typographyProps: {
        size: 14,
        weight: fontConfig.weight.regular,
        forwardAs: "p",
        css: css`
            &&&& {
                line-height: 20px;
            }
        `,
    },
};
